import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AuthGuard} from '../shared/guards/auth.guard';
import {WizardReadyGuard} from '../shared/guards/wizardReady.guard';
import {MobileWizardComponent} from './components/mobile-wizard/mobile-wizard.component';

const routes: Routes = [
    {
        path: '',
        component: MobileWizardComponent,
        canActivate: [AuthGuard, WizardReadyGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WizardRoutingModule {
}
